// extracted by mini-css-extract-plugin
export default {"mainContentBlockWrapper":"mainContentBlock_mainContentBlockWrapper__wFr01","mainContentBlockTitle":"mainContentBlock_mainContentBlockTitle__5ErFh"};